type LoadingIconProps = React.HTMLAttributes<SVGElement>

export const LoadingIcon = ({ className }: LoadingIconProps) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={`animate-spin inline ${className}`}>
      <circle cx="12" cy="12" r="11" fill="transparent" stroke="currentColor" strokeWidth={2} strokeDasharray={52} />
    </svg>
  )
}
